import { useRef, useState } from 'react'
import useDataFetch from '@scentregroup/shared/hooks/use-data-fetch'
import { Centre } from '../../../types/contentful-v1'
import { AlgoliaApiKeys, SegmentHits, DoQueryAlgoliaArgs } from './types'
import {
  makeOffsetlessTimeGetters,
  makeClients,
  doQueryAlgolia,
} from './algolia-helpers'

interface UseAlgoliaReturns {
  results: SegmentHits
  isLoading: boolean
  setQuery: (query: string) => void
  query: string
  isError: boolean
  isInitialised: boolean
}

export default function useAlgolia(
  algoliaApiKeys: AlgoliaApiKeys,
  isEvolved: boolean,
  country: string,
  centre?: Centre,
  initialQuery?: string
): UseAlgoliaReturns {
  const [query, setQuery_] = useState(initialQuery || '')
  const [isError, setIsError] = useState(false)
  const context = {
    country,
    centre,
    isEvolved,
    ...makeOffsetlessTimeGetters(country, centre),
  }
  const clients = useRef(makeClients(algoliaApiKeys))
  const makeInput = (q: string): DoQueryAlgoliaArgs => ({
    clients: clients.current,
    context,
    query: q,
  })
  const fetching = useDataFetch(
    doQueryAlgolia,
    (_err: Error): SegmentHits => {
      // TODO When Sentry becomes available as Context, log the err
      setIsError(true)
      return {}
    },
    initialQuery === undefined ? undefined : makeInput(initialQuery)
  )

  const setQuery = (query_: string): void => {
    setIsError(false)
    fetching.setInput(makeInput(query_))
    setQuery_(query_)
  }
  const results: SegmentHits =
    fetching.status === 'data' && query.length > 0 ? fetching.output : {}
  const isLoading = fetching.status === 'loading'
  const isInitialised = Boolean(clients.current)
  return { query, isLoading, isError, results, setQuery, isInitialised }
}
